window.allInGift = null
try{
  Object.defineProperty(window, 'AllInGift', {
    set: function(AllInGift) {
        const gift = AllInGift.product({hidePurchaseButton: true, hideQuantity: true});
        gift.on("change", function (event) {
          allInGift= event.value;
        });
        gift.mount(document.getElementById("all-in-gift"));
    }
  });
}catch{}


const updateAllInGiftAttributesLocalStorage = (giftProperties) => {
    const allInGiftElement = document.getElementById('all-in-gift');
    const allInGiftElementStyle = window.getComputedStyle(allInGiftElement);

    if(allInGiftElementStyle.display !== "block") return true
    if (!allInGift || !allInGift.value || !allInGift.value.eGift) return false
     if(!allInGift.value.nickname) {
      return false
    }

    const attributes = {
      "ギフト" : true,
      "SNSギフト" : true,
      "ニックネーム" : allInGift.value.nickname
    }

    if(allInGift.value.usage){
      attributes["ギフトの利用用途"] = allInGift.value.usage
    }

    giftProperties[0]["ギフトの種類"] = "eギフト"
    window.localStorage.setItem("allInGift", JSON.stringify(attributes))

    return true
}

const removeAllInGiftAttributesLocalStorage = () => {
  window.localStorage.setItem("allInGift", undefined)
}

const alertEgiftIsInCart = () => {
  alert("eギフト設定をした商品がすでにカートに入っています")    
}

const alertEgiftIsNotInCart = () => {
  alert("eギフト設定のない商品がすでにカートに入っています")    
}
